import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { DataSetupActions } from './data-setup.actions';
import { catchError, mergeMap, of, tap } from 'rxjs';

@Injectable()
export class DataSetupEffects {
  private readonly actions$ = inject(Actions);

  private readonly init$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DataSetupActions.init),
      mergeMap(action => of(DataSetupActions.loadSuccess({ dataSetup: action.dataSetup }))),
      catchError(error => of(DataSetupActions.loadFailure({ error })).pipe(tap(error => console.error(error)))),
    ),
  );
}
